import styled from 'styled-components';
import { StyledLink } from './StyledLink';

export const AssignLink = styled(StyledLink)`
  text-decoration: none;
`;
